export default "__VITE_ASSET__fce5ca2d__"